/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { isObject, mapKeys, isEqual } from 'lodash-es';
import { LoadingPlugin } from './plugin.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import 'vue';
import './loading.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import './icon/gradient.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-b0b0fb5e.mjs';
import '../_chunks/dep-684f6096.mjs';
import '../_chunks/dep-35b16530.mjs';
import '../_chunks/dep-11896cb9.mjs';
import '../utils/dom.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../utils/render-tnode.mjs';
import '../hooks/useTeleport.mjs';
import './props.mjs';

var INSTANCE_KEY = Symbol("TdLoading");
var createInstance = function createInstance(el, binding) {
  var _binding$modifiers = binding.modifiers,
    fullscreen = _binding$modifiers.fullscreen,
    inheritColor = _binding$modifiers.inheritColor;
  var options = {
    attach: function attach() {
      return el;
    },
    fullscreen: fullscreen !== null && fullscreen !== void 0 ? fullscreen : false,
    inheritColor: inheritColor !== null && inheritColor !== void 0 ? inheritColor : false,
    loading: binding.value
  };
  if (isObject(binding.value)) {
    mapKeys(binding.value, function (value, key) {
      options[key] = value;
    });
  }
  el[INSTANCE_KEY] = {
    options: options,
    instance: LoadingPlugin(options)
  };
};
var vLoading = {
  mounted: function mounted(el, binding) {
    if (binding.value) {
      createInstance(el, binding);
    }
  },
  updated: function updated(el, binding) {
    var instance = el[INSTANCE_KEY];
    var value = binding.value,
      oldValue = binding.oldValue;
    if (!isEqual(value, oldValue)) {
      var _value$loading;
      var loading = (_value$loading = value === null || value === void 0 ? void 0 : value.loading) !== null && _value$loading !== void 0 ? _value$loading : value;
      if (loading) {
        createInstance(el, binding);
      } else {
        instance === null || instance === void 0 || instance.instance.hide();
      }
    }
  },
  unmounted: function unmounted(el) {
    var _el$INSTANCE_KEY;
    (_el$INSTANCE_KEY = el[INSTANCE_KEY]) === null || _el$INSTANCE_KEY === void 0 || _el$INSTANCE_KEY.instance.hide();
  }
};

export { vLoading as default, vLoading };
//# sourceMappingURL=directive.mjs.map
